import { Link } from "react-router"

interface Props {
    onCancel?: ()=> void
    onSave?: (e?:any) => void
    message?: string
    error?: boolean
    readonly?: boolean
    noBootstrap?: boolean
}

const FormFooter = (props: Props) => {

    const renderMsgBox = () => {
        return (
          <div className="align-self-start">
          { props?.message  
              ?
              props?.error
              ?
                <>
                  <i className="ti ti-alert-triangle text-danger" />  
                  <span className='text-danger'> {props?.message} </span> 
                </> 
              :
                <>
                  <i className="ti ti-thumb-up text-success" />  
                  <span className='text-success'> {props?.message} </span> 
                </> 
              : <></>
          }
        </div>
        )
    }

    return (
        <div className="d-flex flex-column w-100 gap-2" style={{ 
            justifyContent: "",
            flexDirection:'column'}}>

                {renderMsgBox()}
                <div className="align-self-end">
                  {props.noBootstrap  ? 
                    <Link
                    to = "#"
                      className="btn btn-light me-2"
                      onClick={props.onCancel}
                    >
                      Cancel
                    </Link>
                  : 
                    <Link
                    to = "#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                      onClick={props.onCancel}
                    >
                      Cancel
                    </Link>
                  }
                  <button disabled={props.readonly}
                    className="btn btn-primary" 
                    onClick={props.onSave}
                    >
                    Save
                  </button>
                </div>
        </div>
    )
}

export default FormFooter